import * as R from "ramda";

const split = (prototypes) => {
  return prototypes.split(".");
};
export const withNull = function (prototypes, record) {
  return R.pathOr(null, split(prototypes))(record);
};
export const withEmpty = function (prototypes, record) {
  return R.pathOr("", split(prototypes))(record);
};
export const withArray = function (prototypes, record) {
  return R.pathOr([], split(prototypes))(record);
};
export const withObject = function (prototypes, record) {
  return R.pathOr({}, split(prototypes))(record);
};
export const withBoolean = function (prototypes, record) {
  return R.pathOr(false, split(prototypes))(record);
};
export const withNumber = function (prototypes, record) {
  return R.pathOr(0, split(prototypes))(record);
};
export const updateString = function (prototypes, value, record) {
  return R.assocPath(split(prototypes), R.or("", value), record);
};
export const updateArray = function (prototypes, value, record) {
  return R.assocPath(split(prototypes), R.or([], value), record);
};
export const removeItem = function (index, record) {
  const items = [...record];

  R.pathOr(null, ["id"])(items[index]) == null
    ? items.splice(index, 1)
    : (items[index].isRemove = true);

  return items;
};
export const updateItem = function (prototypes, value, record) {
  return R.assocPath(prototypes, R.or(null, value), record);
};
export const updateObject = function (prototypes, value, record) {
  return R.assocPath(split(prototypes), R.or({}, value), record);
};
export const updateBoolean = function (prototypes, value, record) {
  return R.assocPath(split(prototypes), R.or(false, value), record);
};
export const updateCode = function (prototypes, value, record) {
  return R.assocPath(split(prototypes), R.or(null, value), record);
};
export const withDefaultValue = function (prototypes, record, defaultValue) {
  return R.pathOr(defaultValue, split(prototypes))(record);
};
export const withRandomImage = function (prototypes, record) {
  return R.pathOr("https://picsum.photos/200", split(prototypes))(record);
};
export const withUnique = function (arrays) {
  return R.uniq(arrays);
};
export const orRandomImage = function (value) {
  return R.or(value, "https://picsum.photos/200");
};
export const withNow = function (prototypes, record) {
  const date = withNull(prototypes, record);

  if (date) {
    return new Date(date);
  }

  return new Date();
};
export const groupWith = function (compare, arrays) {
  return R.groupWith((a, b) => compare(a, b), arrays);
};
export const groupBy = function (compare, arrays) {
  const group = R.groupBy((a) => compare(a));

  return group(arrays);
};
export const withFlatten = function (arrays) {
  return R.flatten(arrays);
};
export const withSum = function (arrays) {
  return R.sum(arrays);
};
export const withDifference = function (array_1, array_2) {
  return R.difference(array_1, array_2).length > 0;
};
export const withUnNest = function (array) {
  return R.unnest(array);
};
export const withIncludes = function (value, array) {
  return R.includes(value, array);
};
